
<div class="spinner-container" *ngIf="loading$ | async">

  <mat-spinner></mat-spinner>

</div>
